module.exports = __webpack_public_path__ + "img/bluehouse.28024d07.png";